import { Replacement } from '@/components/domain/creatives/html/string-replacement/Replacement';

export const defaultReplacements: Replacement[] = [
    {
        origin: 'http:',
        replacement: 'https:',
    },
];
